import { FC } from 'react';

import { ColorSegmentsIcon } from './ColorSegmentsIcon';

interface Props {
    readonly iconKey: string;
    readonly className?: string;
}

const INK_COLORS: Record<string, string> = {
    amber: '#f2ad24',
    emerald: '#169c61',
    amethyst: '#8054d6',
    ruby: '#e23c4d',
    steel: '#9aa6b2',
    sapphire: '#267fd0',
};

const INK_PREFIX = 'lorcana_ink_';

export const LorcanaOptionIcon: FC<Props> = ({ iconKey, className }) => {
    const colors = iconKey
        .slice(INK_PREFIX.length)
        .split('_')
        .map((ink) => INK_COLORS[ink])
        .filter(Boolean);

    return <ColorSegmentsIcon colors={colors} className={className} />;
};
